/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

export default function ModalResult({
  selectedUserIdObj,
  modalOpenObj,
  message,
  status = "success",
  autoCloseDelay = 1000,
  ...props
}) {
  useEffect(() => {
    let timerId;
    if (modalOpenObj.modalOpen === true) {
      timerId = setTimeout(() => {
        console.log("Closing modal via timeout");
        if (
          modalOpenObj.setModalOpen &&
          typeof modalOpenObj.setModalOpen === "function"
        ) {
          modalOpenObj.setModalOpen(false);
        }
      }, autoCloseDelay);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [modalOpenObj.modalOpen, autoCloseDelay]);

  const getStatusStyles = () => {
    if (status === "success") {
      return {
        icon: "/img/icons/icon-success.png",
        textColor: "#5A5A5A",
      };
    } else {
      return {
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 83 83"
            width="83"
            height="83"
          >
            <circle cx="41.5" cy="41.5" r="41.5" fill="#FFE5E6" />
            <circle cx="41.5" cy="41.5" r="33" fill="#F95057" />
            <path
              d="M54.5 29.5L29.5 54.5M29.5 29.5L54.5 54.5"
              stroke="white"
              strokeWidth="6"
              strokeLinecap="round"
            />
          </svg>
        ),
        textColor: "#F95057",
      };
    }
  };

  const { icon, textColor } = getStatusStyles();

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpenObj.modalOpen}
        onClose={() => modalOpenObj.setModalOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div className="bg-white w-fit p-[min(2.44vw,25px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-24 text-[var(--color-black-2)] text-center leading-[1.8] font-[500]">
            <div className="flex flex-col items-center ">
              {typeof icon === "string" ? (
                <img
                  className="w-[min(8.11vw,83px)] aspect-square object-contain rounded-full"
                  src={icon}
                  alt={status === "success" ? "Success" : "Failure"}
                />
              ) : (
                <div className="w-[min(8.11vw,83px)] aspect-square">{icon}</div>
              )}
              <div
                className="leading-[1.6] font-[500] text-center mt-[min(2.44vw,25px)]"
                style={{ color: textColor }}
              >
                {message ||
                  (status === "success" ? "ดำเนินการสำเร็จ" : "เกิดข้อผิดพลาด")}
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
